import Swal from 'sweetalert2';

const lang = document.documentElement.lang;
const tr = {
  'pt-BR': {
    modal_attention: 'Atenção!',
    modal_hours: 'Preencha as horas corretamente',
  },
  en: {
    modal_attention: 'Attention!',
    modal_hours: 'Please fill out the hours correctly.',
  },
  es: {
    modal_attention: '¡Atención!',
    modal_hours: 'Rellena las horas correctamente',
  },
};

export const presenceHours = () => {
  const $form = document.getElementById('form');
  const $search = document.getElementById('search');
  const $tdlist = document.querySelectorAll('#form tbody tr td');
  const $trlist = document.querySelectorAll('#form tbody tr');
  const $timeP = document.querySelector('[name="total_time_planning"]');
  const $timeA = document.querySelector('[name="total_time_action"]');
  const $individualInputs = document.querySelectorAll('[data-individual]');
  let error = false;

  $timeP.addEventListener('input', e => validateParentInputs(e));
  $timeA.addEventListener('input', e => validateParentInputs(e));

  const validateParentInputs = e => {
    const $spanError = e.target.parentNode.nextElementSibling;
    if (e.target.value.length < 5 || parseInt(e.target.value.split(':')[1]) > 59) {
      error = true;
      if ($spanError.hasAttribute('data-error')) {
        $spanError.style.display = 'block';
      }
    } else {
      error = false;
      if ($spanError.hasAttribute('data-error')) {
        $spanError.style.display = 'none';
      }
      splitHours();
    }
  };

  const splitHours = () => {
    const timePValue = $timeP.value || '00:00';
    const timeAValue = $timeA.value || '00:00';

    const timePMinutes = parseInt(timePValue.split(':')[0]) * 60 + parseInt($timeP.value.split(':')[1]);
    const timeAMinutes = parseInt(timeAValue.split(':')[0]) * 60 + parseInt($timeA.value.split(':')[1]);

    const individualMinutes = timeAMinutes;
    const leaderMinutes = individualMinutes + timePMinutes;

    if (individualMinutes && leaderMinutes) {
      $individualInputs.forEach(el => {
        el.closest('table').removeAttribute('data-last-td-gray');
        el.closest('table').setAttribute('data-last-td-brand', '');

        if (el.hasAttribute('data-leader')) {
          el.value = minutesToHHMM(leaderMinutes);
        } else {
          el.value = minutesToHHMM(individualMinutes);
        }
      });
    }
  };

  const minutesToHHMM = minutes => {
    const m = Math.floor(minutes % 60);

    const h = Math.floor((minutes - m) / 60);

    const HHMM = (h < 10 ? '0' : '') + h.toString() + ':' + (m < 10 ? '0' : '') + m.toString();

    return HHMM;
  };

  $form.addEventListener('submit', e => {
    if (error || $timeP.value.length < 5 || $timeA.value.length < 5) {
      e.preventDefault();

      Swal.fire({
        icon: 'error',
        title: tr[lang].modal_attention,
        text: tr[lang].modal_hours,
      });
    }

    $individualInputs.forEach(el => {
      if (el.value.length < 5 || el.value.split(':')[1] > 59) {
        e.preventDefault();
        el.classList.add('error');
        Swal.fire({
          icon: 'error',
          title: tr[lang].modal_attention,
          text: tr[lang].modal_hours,
        });
      }
    });
  });

  $individualInputs.forEach(el => {
    el.addEventListener('input', e => e.target.classList.remove('error'));
  });

  $search.addEventListener('input', e => {
    const keyword = e.target.value.toLowerCase();

    if (keyword.length) {
      if ($trlist) {
        $trlist.forEach(el => (el.style.display = 'none'));
      }
      if ($tdlist) {
        $tdlist.forEach(el => {
          el.textContent.toLowerCase().includes(keyword) && el.closest('tr').removeAttribute('style');
        });
      }
    } else {
      $trlist.forEach(el => el.removeAttribute('style'));
    }
  });
};
